<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <div class="container text-left mt-2 mb-2 text-playgame">
        ดาวน์โหลด
      </div>
      <div>
        <img
          width="100%"
          height="100%"
          src="../assets/download-mobile/Download-amb-poker.png"
          alt="download_banner"
        />
      </div>
      <div class="justify-content-center">
        <div class="download-button-container">
          <input
            type="button"
            class="download-button"
            value="Android"
            @click="downloadAndroid()" />
        </div>
      </div>
    </div>
    <div class="maincontent-bg-end"></div>
  </div>
</template>

<script>
export default {
  name: 'download',
  methods: {
    downloadAndroid() {
      window.location.href = `${this.$urlDownload}`;
    },
  },
};
</script>

<style scoped></style>
